// frontend/src/patient/ActivePatientWidget.js
//
// Flytande widget nere till höger som syns på ALLA sidor när en patient är
// aktiv (patientjournalen öppnad). Gör att man kan boka i kalendern eller
// gå till startsidan utan att tappa patienten — och hitta tillbaka.
//
//   "Inne på [Patient X]"   [Öppna]  [Stäng journal]
//
// Öppna → patientens översikt. Stäng journal → rensar aktiv patient.

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActivePatient } from './ActivePatientContext';
import './ActivePatientWidget.css';

const ActivePatientWidget = () => {
  const ctx = useActivePatient();
  const navigate = useNavigate();

  const hasPatient = !!(ctx && ctx.activePatient);

  // Medan widgeten är synlig reserverar vi botten-utrymme i den scrollande
  // innehållsytan (via body-klass → CSS), så sidans knappar ("Betala besök"
  // m.fl.) alltid kan scrollas fram OVANFÖR den flytande widgeten i stället
  // för att fastna bakom den — oavsett var i layouten knappen råkar hamna
  // (t.ex. journalflikens smala detaljkolumn på delad skärm).
  useEffect(() => {
    document.body.classList.toggle('has-active-patient', hasPatient);
    return () => document.body.classList.remove('has-active-patient');
  }, [hasPatient]);

  if (!hasPatient) return null;
  const { activePatient, clearActivePatient } = ctx;

  // Widgeten ligger nere till VÄNSTER (se CSS) — medvetet skild från
  // inspelningsraden, toasts och sidans knappar som bor nere till höger, så
  // ingen behöver längre "lyftas" undan de andra.

  const openPatient = () => {
    navigate(`/patients/${activePatient.patient_id}`);
  };

  return (
    <div className="active-patient-widget">
      <span className="apw-label">
        <i className="fas fa-user-injured"></i>
        <span className="apw-text">
          Inne på <strong>{activePatient.fullname || 'patient'}</strong>
        </span>
      </span>
      <button className="apw-btn" onClick={openPatient}>
        <i className="fas fa-folder-open"></i> Öppna
      </button>
      <button className="apw-btn apw-close" onClick={clearActivePatient}
              title="Rensar den aktiva patienten ur minnet">
        <i className="fas fa-times"></i> Stäng journal
      </button>
    </div>
  );
};

export default ActivePatientWidget;
